
import SEOHelmet from './seo/SEOHelmet';
import OpenGraphMeta from './seo/OpenGraphMeta';
import LocalBusinessSchema from './seo/LocalBusinessSchema';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogType?: string;
  ogImage?: string;
  structuredData?: Record<string, any>;
  localBusiness?: {
    city?: string;
    region?: string;
    postalCode?: string;
    serviceType?: string;
  };
  robots?: string;
  keywords?: string;
  author?: string;
  preloadImages?: string[];
  alternateLanguages?: { hreflang: string; href: string }[];
  articleData?: {
    datePublished?: string;
    dateModified?: string;
    author?: string;
    section?: string;
  };
}

const SEO = ({ 
  title = "Groupe Fabre Environnement - Recyclage et Valorisation de Déchets", 
  description = "Groupe Fabre Environnement, votre partenaire pour la gestion et valorisation des déchets depuis plus de 25 ans",
  canonical = "",
  ogType = "website",
  ogImage = "https://lovable.dev/opengraph-image-p98pqg.png",
  structuredData = {},
  localBusiness,
  robots = "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
  keywords = "recyclage, déchets, valorisation, métaux, bennes, environnement, Groupe Fabre",
  author = "Groupe Fabre Environnement",
  preloadImages = [],
  alternateLanguages = [],
  articleData
}: SEOProps) => {
  
  const baseUrl = "https://www.groupefabre-environnement.fr";
  const fullCanonical = canonical ? `${baseUrl}${canonical}` : baseUrl;
  
  return (
    <>
      <SEOHelmet
        title={title}
        description={description}
        keywords={keywords}
        author={author}
        robots={robots}
        canonical={fullCanonical}
        preloadImages={preloadImages}
        alternateLanguages={alternateLanguages}
        articleData={articleData}
        localBusiness={localBusiness}
      />
      
      <OpenGraphMeta
        title={title}
        description={description}
        canonical={fullCanonical}
        ogType={ogType}
        ogImage={ogImage}
      />
      
      {localBusiness && Object.keys(structuredData).length === 0 && (
        <LocalBusinessSchema
          localBusiness={localBusiness}
          title={title}
          description={description}
          canonical={fullCanonical}
          ogImage={ogImage}
        />
      )}
      
      {/* Custom structured data if provided */}
      {Object.keys(structuredData).length > 0 && (
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
        </Helmet>
      )}
    </>
  );
};

export default SEO;
